import { useLazyQuery } from "@apollo/client/react"; import React, { Fragment, useState, useEffect } from "react";

import { CustomChip } from "../../../components/chip/Chip";
import { Box, Grid, CardContent, Card } from '@mui/material';
import { CustomButton } from '../../../components/customButton/CustomButton';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import './indicaciones.scss';
import { GET_INFO_DIRECCION_RI } from "../../../data/graphQL/queries/ResumenIngresoValidation/infoDireccionRI";

export const DireccionRI = ({ idDatosGenerales, setChildrenAction, setApto }) => {
  const navigate = useNavigate();
  const [resumenIngreso, setResumenIngreso] = useState({});

  function ItemR(props) {
    const { sx, ...other } = props;
    return (
      <Box
        sx={{
          bgcolor: (theme) => theme.palette.mode === 'dark' ? '#101010' : '#fff',
          color: (theme) => theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
          borderRadius: 0,
          fontSize: '0.75rem',
          ...sx,
          padding: 1
        }}
        {...other} />);


  }

  ItemR.propTypes = {
    sx: PropTypes.oneOfType([
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
      ),
      PropTypes.func,
      PropTypes.object]
    )
  };

  const handleClickNavigate = () => {
    navigate('/resumenIngreso/detalle',
      {
        state: {
          idDatosGeneralesRI: idDatosGenerales,
          edit: false
        }
      });
  };

  const [getInfoDireccionRI, { loading: resumenIngresoLoading, data: riData }] = useLazyQuery(GET_INFO_DIRECCION_RI, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!riData) return;

    setResumenIngreso(riData?.infoDireccionRIByIdDatosGeneralesRI);
    const aptoValue = !riData?.infoDireccionRIByIdDatosGeneralesRI?.apto.toUpperCase().includes("NO");
    setApto(aptoValue);
  }, [riData]);

  useEffect(() => {
    if (!resumenIngresoLoading && !!idDatosGenerales) {
      getInfoDireccionRI({ variables: { idDatosGenerales } });
    }
  }, [idDatosGenerales]);

  useEffect(() => {
    if (!idDatosGenerales) return setChildrenAction(null);

    setChildrenAction(() =>
      <CustomButton
        onClick={handleClickNavigate}
        size='small'
        variant='outlined'
        isLoading={resumenIngresoLoading}>

        Ver Resumen
      </CustomButton>
    );

  }, [idDatosGenerales]);

  return <Grid
    sx={{ marginTop: '10px' }}
    container
    columns={100}
    columnSpacing={2}
    rowSpacing={1}>

    {inputsCabecera.map((input, index) => {
      return (
        <Fragment key={`name-${input.name}-index${index}`}>
          {input.whiteSpace ?
            <Grid sx={{ marginLeft: '10px' }} size={{ xs: 100, sm: 100, md: 77, lg: 77 }}>

            </Grid> :

            <Grid sx={{ marginLeft: '10px' }} size={{ xs: 100, sm: 50, md: 23, lg: 23 }}>
              {<ItemR> <strong> {input.displayName} </strong> </ItemR>}
              {<ItemR> {resumenIngreso[input.name] || '-'} </ItemR>}
            </Grid>
          }
        </Fragment>);

    })}
  </Grid>;
};

const inputsCabecera = [
  {
    displayName: 'Paciente Apto',
    name: 'apto'
  },
  {
    displayName: 'item',
    name: 'item',
    whiteSpace: true
  },
  {
    displayName: 'Direccion del paciente',
    name: 'direccion'
  },
  {
    displayName: 'Localidad',
    name: 'localidad'
  },
  {
    displayName: 'Provincia',
    name: 'provincia'
  },
  {
    displayName: 'Zona desfavorable',
    name: 'zonaDesfavorable'
  }];